import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCollapse from 'react-collapse';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Vehicle } from '@sm360/widget-commons-vehicle';
import { CatalogModelSummary } from '@sm360/widget-commons-tiles';

import './Disclaimer.scss';

class Disclaimer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.onButtonClick = this.onButtonClick.bind(this);
    }

    onButtonClick() {
        this.setState((previousState) => {
            return { open: !previousState.open };
        });
    }

    render() {
        return (
            <div>
                <button className="sr-link" onClick={this.onButtonClick}>
                    {this.state.open
                        ? LocaleService.t('CATALOG_DISCLAIMER.HIDE')
                        : LocaleService.t('CATALOG_DISCLAIMER.OPEN')}
                </button>
                <div className="vehicle-note__wrapper">
                    <ReactCollapse isOpened={this.state.open} springConfig={{ stiffness: 270, damping: 30 }}>
                        <div className="sr-disclaimer is-light">
                            <Vehicle.VehicleDisclaimersContent disclaimers={this.props.model.disclaimer} />
                        </div>
                    </ReactCollapse>
                </div>
            </div>
        );
    }
}

Disclaimer.propTypes = {
    model: PropTypes.instanceOf(CatalogModelSummary).isRequired,
};

Disclaimer.displayName = 'Disclaimer';

export default Disclaimer;



// WEBPACK FOOTER //
// /builds/development/frontend/widgets/widgets/components/tiles/tile-a/src/components/Tile/Catalog/sections/Disclaimer.jsx